import React, { useState } from 'react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { Combobox } from '@headlessui/react'
import { kebabCase } from 'lodash'

export default function SearchList({ props }) {
    const { heading, searchPlaceholder, successMessage } = props
    const list = props?.listItems?.split(/\r?\n/)
    const [query, setQuery] = useState('')
    const [selectedItem, setSelectedItem] = useState(null)
    const filteredItems =
        query === ''
            ? list
            : list.filter((item) => {
                return item.toLowerCase().includes(query.toLowerCase())
            })

    return (
        <section className="pt-10 pb-12 md:pt-16 md:pb-20 md:bg-banner-gradient/10">
            <div className="container">
                <Combobox as="div" value={selectedItem} className="max-w-2xl lg:mx-auto" nullable onChange={setSelectedItem}>

                    <Combobox.Label as="h2" id={kebabCase(heading)} className="lg:text-center ">{heading}</Combobox.Label>
                    <div className="relative mt-3 lg:mt-4">
                        <Combobox.Input
                            className="w-full rounded-md border border-green bg-white py-2 pl-3 pr-10  focus:border-green-500 focus:outline-none focus:ring-1 focus:ring-green-500"
                            onChange={(event) => setQuery(event.target.value)}
                            placeholder={searchPlaceholder}
                            displayValue={(item) => item || ''}
                        />
                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </Combobox.Button>

                        {filteredItems?.length > 0 && (
                            <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded bg-white py-1 text-base shadow-spread ring-1 ring-black ring-opacity-5 focus:outline-none">
                                {filteredItems.map((item) => (
                                    <Combobox.Option
                                        key={item}
                                        value={item}
                                        className={({ active }) =>
                                            `relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-green/5`
                                        }
                                    >
                                        {({ active, selected }) => (
                                            <>
                                                <span className={`block truncate`}>{item}</span>
                                                {/* <span
                                                className={`absolute inset-y-0 right-0 flex items-center pr-4`}
                                            >
                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                            </span> */}

                                            </>
                                        )}
                                    </Combobox.Option>
                                ))}
                            </Combobox.Options>
                        )}


                    </div>
                    {selectedItem && successMessage ? <div className="mt-4 text-center"><CheckIcon className="w-6 text-green flex-shrink-0 mr-1 inline-block -mt-1" /><span className="">{successMessage} <span className="font-semibold">{selectedItem}</span></span></div> : null}

                </Combobox>
            </div>
        </section>
    )
}